// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const GetGoalCategoryCount = CreateProcess({
	method: "GET",
	name: "GetGoalCategoryCount",
	type: "COMPANY:GOALCATEGORIES.COUNT",

	request: (props) => ({
		url: `/api/companies/${props.companyID}/goal-categories/count/`,
	}),

	success: (response) => fromJS(response.data),
});

export const getFields = CreateProcess({
	method: "GET",
	name: "GetCompanyFields",
	type: "COMPANY:FIELDS",

	request: (props) => {
		const companyID = props.params ? props.params.companyID : props.companyID;
		const offset = props?.offset ? `offset=${props.offset}` : "";
		const limit = props?.limit ? `limit=${props.limit}` : "";
		const params = offset.length + limit.length > 0 ? `?${offset}&${limit}` : "";
		return {
			url: `/api/v0.1/companies/${companyID}/fields/${params}`,
		};
	},

	success: (response) => {
		const fields = response.data.fields.map((field) => ({
			editableBy: field["editable-by"],
			id: field.id,
			name: field.name,
			label: field.name,
			tags: field.tags,
			type: field.type,
			visibleTo: field["visible-to"],
		}));

		return fromJS(fields);
	},
});

export const generateEmployeeCsv = CreateProcess({
	method: "GET",
	name: "GenerateEmployeeCSV",
	type: "COMPANY:GENERATEEMPLOYEECSV",

	request: (props) => ({
		url: `/api/export/employees/?directoryFields=${props.directoryFields}`,
	}),

	success: (response) => fromJS(response.data),
});
